import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import { GET_EVENT_QUERY_KEY } from '@/state/queries/events/use-get-event.ts';
import { GET_EVENT_FLOWS_QUERY_KEY } from '@/state/queries/flows/use-get-event-flows';
import { GET_EVENT_CONTRIBUTORS_QUERY_KEY } from '@/state/queries/contributors/use-get-event-contributors';
import { invalidatePublicationStateQueries } from '@/state/queries/events/use-publication-state';

type DeleteEventSlotDto = {
  eventId: string;
  slotId: string;
};

export const useDeleteEventSlotMutation = () => {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: DeleteEventSlotDto) => {
      const token = await getToken();
      return deleteEventSlot(data, token ?? '');
    },
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: [GET_EVENT_QUERY_KEY] }),
        queryClient.invalidateQueries({ queryKey: [GET_EVENT_FLOWS_QUERY_KEY] }),
        queryClient.invalidateQueries({ queryKey: [GET_EVENT_CONTRIBUTORS_QUERY_KEY] }),
        invalidatePublicationStateQueries(queryClient),
      ]);
    },
  });
};

const deleteEventSlot = async (data: DeleteEventSlotDto, token: string) => {
  const url = `${import.meta.env.VITE_API_URL}/events/${data.eventId}/slots/${data.slotId}`;
  return sendRequest({ url, method: METHOD.DELETE, token });
};
